import React from "react";

import Header from "../components/Header";
import HeroComponent from "../components/HeroComponent.js";
import FooterComponent from "../components/FooterComponent.js";
import { useLanguage } from "../contexts/LanguageContext";

const Home = () => {
  const { language } = useLanguage();
  return (
    <div className="relative bg-cream">
      <Header />
      <HeroComponent />

      {/* About Us Section */}
      <section className="max-w-6xl mx-auto px-6 py-24">
        <div className="text-center mb-16">
          <p className="text-xs tracking-[0.3em] uppercase text-gold mb-4 font-light">
            {language === "pt" ? "A Nossa História" : "Our Story"}
          </p>
          <h2 className="font-display text-5xl md:text-6xl text-stone-800 mb-4">
            {language === "pt" ? "Sobre Nós" : "About Us"}
          </h2>
          <p className="text-stone-400 font-light max-w-md mx-auto text-sm leading-relaxed">
            {language === "pt"
              ? "Aprenda um pouco sobre mim e como criei a marca."
              : "Learn a little about me and how I came up with the brand."}
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24">
          <div className="flex-1 space-y-6 font-serif text-stone-600 text-base leading-loose lg:text-lg">
            {language === "pt" ? (
              <>
                <p>
                  O nome{" "}
                  <strong className="text-stone-800 font-medium">
                    Tam Tam
                  </strong>{" "}
                  é uma homenagem ao meu Pai, inspirado na loja que ele tinha na
                  Beira, em Moçambique, a cidade onde nasci. Esta ligação às
                  raízes e às memórias da infância é a alma da marca, trazendo
                  consigo o encanto das histórias e dos lugares que fazem parte
                  de mim.
                </p>
                <p>
                  Cada peça que crio tem um pedacinho do mundo. Os materiais que
                  uso são adquiridos durante as minhas viagens ou, pelo menos,
                  as inspirações surgem de tesouros descobertos nesses momentos.
                  Assim, cada joia não é apenas um acessório, mas uma recordação
                  de aventuras, culturas e experiências vividas.
                </p>
                <p>
                  O gosto por trabalhos manuais vem da minha Mãe, que me ensinou
                  desde cedo a amar o croché, a costura e outras formas de criar
                  com as mãos. Com essa herança, comecei de forma modesta, com
                  uma pequena coleção de peças feitas para amigas, mas com muito
                  amor e dedicação.
                </p>
                <p className="text-stone-400 italic">
                  Com carinho,
                  <br />
                  <span className="text-stone-700 not-italic font-medium">
                    Graça Soares
                  </span>
                </p>
              </>
            ) : (
              <>
                <p>
                  The name{" "}
                  <strong className="text-stone-800 font-medium">
                    "Tam Tam"
                  </strong>{" "}
                  is a heartfelt tribute to my Father, inspired by his shop in
                  Beira, Mozambique, the city of my birth. This connection to my
                  roots and childhood memories is the very soul of the brand,
                  carrying with it the enchantment of stories and places that
                  are a part of me.
                </p>
                <p>
                  Each piece I create holds a fragment of the world within it.
                  The materials I use are often acquired on my travels, or, at
                  least, the inspirations come from treasures discovered in
                  those moments. Thus, each jewel is not just an accessory, but
                  a memory of adventures, cultures and experiences lived.
                </p>
                <p>
                  The love for handicrafts comes from my mother, who taught me
                  from an early age to love crochet, sewing and other ways of
                  creating with my hands. With this heritage, I started
                  modestly, with a small collection of pieces made for friends,
                  but with a lot of love and dedication.
                </p>
                <p className="text-stone-400 italic">
                  With love,
                  <br />
                  <span className="text-stone-700 not-italic font-medium">
                    Graça Soares
                  </span>
                </p>
              </>
            )}
          </div>

          <div className="flex-shrink-0">
            <img
              src={require(`../assets/author.jpeg`)}
              alt={language === "pt" ? "Perfil" : "Profile"}
              className="w-72 h-72 lg:w-96 lg:h-96 object-cover rounded-full shadow-xl"
            />
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="flex items-center justify-center gap-4 py-4">
        <div className="h-px w-24 bg-stone-200" />
        <div className="w-1.5 h-1.5 rounded-full bg-gold" />
        <div className="h-px w-24 bg-stone-200" />
      </div>

      {/* Instagram section */}
      <section className="max-w-3xl mx-auto px-6 py-20 text-center">
        <a
          href="https://www.instagram.com/tamtambygs/"
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-block"
        >
          <img
            src={require("../assets/logo-insta.png")}
            alt={language === "pt" ? "Logo do Instagram" : "Instagram logo"}
            className="w-20 h-20 mx-auto mb-6 rounded-xl group-hover:opacity-80 transition-opacity"
          />
        </a>
        <h3 className="font-display text-4xl md:text-5xl text-stone-800 mb-4">
          {language === "pt"
            ? "Siga-nos no Instagram"
            : "Follow Us on Instagram"}
        </h3>
        <p className="text-stone-400 font-light text-sm leading-relaxed">
          {language === "pt" ? (
            <>
              Siga-nos no instagram{" "}
              <a
                href="https://www.instagram.com/tamtambygs/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold hover:text-gold-dark transition-colors underline underline-offset-4"
              >
                @tamtambygs
              </a>{" "}
              e marque-nos para ser destacado na nossa timeline
            </>
          ) : (
            <>
              Follow us on instagram{" "}
              <a
                href="https://www.instagram.com/tamtambygs/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold hover:text-gold-dark transition-colors underline underline-offset-4"
              >
                @tamtambygs
              </a>{" "}
              and tag us to get featured on our timeline
            </>
          )}
        </p>
      </section>

      <FooterComponent />
    </div>
  );
};

export default Home;
